
const CodeOfPractice = () => {
	const url =
		"https://storage.googleapis.com/instant-med-public/Telehealth%20Code%20of%20Practice_Wesfarmers%20Health.pdf#navpanes=0&toolbar=0";

	return (
		<div className="mx-auto py-12">
			<h1 className="text-center mb-12">Telehealth Code of Practice</h1>
			<div className="h-screen max-w-[800px] mx-auto mb-4">
				<iframe src={url} className="w-full h-full"></iframe>
			</div>
		</div>
	);
};

export default CodeOfPractice;
